var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTasks = function SvgTasks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M8 40a2 2 0 0 1 2-2h50a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2zm51 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-46-1.5a1.5 1.5 0 0 0 0 3h21a1.5 1.5 0 0 0 0-3z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD2A8",
    fillRule: "evenodd",
    d: "M11 57a2 2 0 0 1 2-2h44a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H13a2 2 0 0 1-2-2zm46 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-42-1.5a1.5 1.5 0 0 0 0 3h21a1.5 1.5 0 0 0 0-3z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M5 8a2 2 0 0 1 2-2h56a2 2 0 0 1 2 2v23a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm54 11.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0m-48-7a1.5 1.5 0 0 0 0 3h25a1.5 1.5 0 0 0 0-3zM9.5 20a1.5 1.5 0 0 1 1.5-1.5h21a1.5 1.5 0 0 1 0 3H11A1.5 1.5 0 0 1 9.5 20m1.5 4.5a1.5 1.5 0 0 0 0 3h17a1.5 1.5 0 0 0 0-3z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2F68D1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m46.985 19.337 2.578 2.578 4.788-4.788"
  })));
};
export default SvgTasks;